import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Dialog
} from "vant"
import PayedText from '../views/TextDetail/payText/index.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/login',
  },
  { //登录
    path: '/login',
    name: 'login',
    component: () => import("@/views/Login"),
  },
  // 申请加入
  {
    path: '/applyTojoin',
    name: 'appTojoin',
    component: () => import("@/views/applyTojoin"),
  },
  { //图文详情
    path: '/textDetail',
    name: 'textDetail',
    component: () => import("@/views/TextDetail"),
  },
  { //图文详情-付费
    path: '/payText',
    name: 'payText',
    component: PayedText,
  },
  { //线上训练营
    path: '/onlineTrainingDetail',
    name: 'onlineTrainingDetail',
    component: () => import("@/views/OnlineTrainingDetail"),
  },
  { //线下训练营
    path: '/offlineTrainingDetail',
    name: 'offlineDetail',
    component: () => import("@/views/OfflineTrainingDetail"),
  },
  { //音频详情
    path: '/audioDetail',
    name: 'audioDetail',
    component: () => import("@/views/AudioDetail"),
  },
  { //视频详情
    path: '/videoDetail',
    name: 'videoDetail',
    component: () => import("@/views/VideoDetail"),
    children: [{ //视频详情-单课未购
      path: 'unpurchased',
      name: 'unchased',
      component: () => import("@/views/VideoDetail/UnpurchasedPage"),
    }, ],
    meta: {
      showfater: true
    }
  },
  { //直播详情
    path: '/liveDetail',
    name: 'liveDetail',
    component: () => import("@/views/LiveDetail/details"),
  },
  {
    path: '/liveDetail/liveColumn',
    name: 'liveColumn',
    component: () => import("@/views/LiveDetail/liveColumn"),
  },
  // 评估-我的评估
  {
    path: '/myEstimate',
    name: 'myEstimate',
    component: () => import("@/views/Estimates/myEstimate"),
    children: [{
      path: 'testPaper',
      name: 'testPaper',
      component: () => import("@/views/Estimates/examDetail/testPaper"),
    }, ],
    meta: {
      showfater: true
    }
  },
  // 课程已下架
  {
    path: '/undercarriage',
    name: 'undercarriage',
    component: () => import("@/views/undercarriage"),
  },

  // { path: '*', redirect: '/', hidden: true },
]

const router = new VueRouter({
  // mode: 'history',
  routes,
  // 控制页面跳转定位到顶部位置
  scrollBehavior(to, from, savePosition) {
    return {
      y: 0
    }
  }
})

// 挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     if (localStorage.getItem("TOKEN_KEY")) {
//       next()
//     } else {
//       Dialog.alert({
//         message: '您还没有登录，请先登录',
//       }).then(() => {
//         let url = `/login?redirect=` + to.fullPath
//         router.push(url)
//       });
//     }
//   }
// })

export default router